import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { QueueIndicators } from '../features/queue/indicators';
import { BRAND } from './brand';
import { useTheme, type ThemeChoice } from './theme';

const NEXT: Record<ThemeChoice, ThemeChoice> = { system: 'light', light: 'dark', dark: 'system' };
const THEME_LABEL: Record<ThemeChoice, string> = { system: 'Theme: system', light: 'Theme: light', dark: 'Theme: dark' };

function navClass({ isActive }: { isActive: boolean }) {
  return `rounded-md px-3 py-1.5 text-sm ${isActive ? 'bg-accent-soft text-ink' : 'text-ink-2 hover:text-ink'}`;
}

export function Layout() {
  const [theme, setTheme] = useTheme();
  const inApp = useLocation().pathname.startsWith('/app');
  return (
    <div className="flex h-full flex-col">
      <QueueIndicators />
      <header className="flex shrink-0 items-center gap-2 border-b border-line bg-paper px-4 py-2">
        <NavLink to="/" className="mr-3 flex items-center gap-2 font-serif text-xl font-semibold">
          <img src="/favicon.svg" alt="" className="h-7 w-7" />
          {BRAND}
        </NavLink>
        <nav className="flex items-center gap-1" aria-label="Main">
          <NavLink to="/app" className={navClass}>Workspace</NavLink>
          <NavLink to="/library" className={navClass}>Library</NavLink>
          <NavLink to="/settings" className={navClass}>Settings</NavLink>
          <NavLink to="/help" className={navClass}>Help</NavLink>
          <NavLink to="/about" className={navClass}>About</NavLink>
        </nav>
        <button
          type="button"
          onClick={() => setTheme(NEXT[theme])}
          className="ml-auto rounded-md border border-line px-3 py-1.5 text-sm text-ink-2 hover:text-ink"
          aria-label={`${THEME_LABEL[theme]}. Click to change.`}
        >
          {theme === 'system' ? 'Auto' : theme === 'light' ? 'Light' : 'Dark'}
        </button>
      </header>
      <main className={inApp ? 'min-h-0 flex-1' : 'flex-1 overflow-y-auto'}>
        <Outlet />
      </main>
    </div>
  );
}
